import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import layoutHeaderAside from '@/layout/header-aside';

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
var _import = require('@/libs/util.import.' + process.env.NODE_ENV);
var meta = {
  cache: process.env.VUE_APP_ENV !== 'dev'
  // cache:true
};
/**
 * 在主框架内显示
 */
var roles = ['合伙人', '经理', '现场负责人', '独立质控合伙人', '独立质控人', '查询人', '维护人', '函证中心管理员', '发函操作员', '回函操作员'];
var _asyncRoutes = [
// 首页
{
  path: 'index',
  name: 'index',
  meta: _objectSpread(_objectSpread({
    title: '首页'
  }, meta), {}, {
    auth: true
  }),
  // redirect: { name: 'correspondence-task' }
  component: _import('system/index')
}, {
  path: '/correspondence/control/:id',
  name: 'correspondence-control',
  props: true,
  meta: _objectSpread(_objectSpread({
    title: '函证作业'
  }, meta), {}, {
    permission: ['合伙人', '经理', '现场负责人', '独立质控合伙人', '独立质控人', '查询人', '维护人', '函证中心管理员'],
    base: true
  }),
  component: _import('correspondence/components/list')
}, {
  path: '/correspondence/control-history/:id',
  name: 'history-control-list1',
  props: true,
  meta: _objectSpread(_objectSpread({
    title: '函证作业'
  }, meta), {}, {
    permission: ['合伙人', '经理', '现场负责人', '独立质控合伙人', '独立质控人', '查询人', '维护人', '函证中心管理员'],
    base: true
  }),
  component: _import('correspondence/components/history-list')
}, {
  path: '/correspondence/control-list/:id?',
  name: 'correspondence-control-list',
  props: true,
  meta: _objectSpread(_objectSpread({
    title: '函证-函证控制表'
  }, meta), {}, {
    permission: ['合伙人', '经理', '现场负责人', '独立质控合伙人', '独立质控人', '查询人', '维护人', '函证中心管理员'],
    base: true
  }),
  // component: _import('system/error/404')
  component: _import('correspondence/control')
}, {
  path: '/correspondence/distribute',
  name: 'correspondence-distribute',
  props: true,
  meta: _objectSpread(_objectSpread({
    title: '函证-统一分发',
    isCpscAdmin: true
  }, meta), {}, {
    permission: ['发函操作员', '回函操作员', '函证中心管理员'],
    base: true
  }),
  component: _import('correspondence/distribute')
}, {
  path: '/correspondence/interactive',
  name: 'correspondence-interactive',
  meta: _objectSpread(_objectSpread({
    title: '发函交互'
  }, meta), {}, {
    base: true
  }),
  // redirect: { name: 'correspondence-task' }
  component: _import('interactive/index')
}, {
  path: '/correspondence/control-list-detail/:taskId/:id',
  name: 'correspondence-control-list-detail',
  props: true,
  meta: _objectSpread(_objectSpread({
    title: '函证-函证控制表明细'
  }, meta), {}, {
    permission: ['合伙人', '经理', '现场负责人', '独立质控合伙人', '独立质控人', '查询人', '维护人', '函证中心管理员'],
    base: true
  }),
  component: _import('correspondence/control/components/list')
}, {
  path: '/correspondence/object/:id?',
  name: 'correspondence-object',
  props: true,
  meta: _objectSpread(_objectSpread({
    title: '函证-发函对象'
  }, meta), {}, {
    permission: ['合伙人', '经理', '现场负责人', '独立质控合伙人', '独立质控人', '查询人', '维护人', '函证中心管理员'],
    base: true
  }),
  component: _import('correspondence/object')
},
// {
//   path: '/correspondence/reminder',
//   name: 'correspondence-reminder',
//   meta: {
//     title: '函证-催函管理',
//     ...meta,
//     permission: 'isGroup'
//   },
//   component: _import('correspondence/reminder')
// },
// {
//   path: '/correspondence/reply',
//   name: 'correspondence-reply',
//   meta: {
//     title: '函证-回函管理',
//     ...meta,
//     permission: 'isGroup'
//   },
//   component: _import('correspondence/reply')
// },
{
  path: '/correspondence/send',
  name: 'correspondence-send',
  meta: _objectSpread(_objectSpread({
    title: '函证-函证管控',
    isCpscAdmin: true
  }, meta), {}, {
    permission: ['发函操作员', '回函操作员', '函证中心管理员'],
    base: true
  }),
  props: true,
  component: _import('correspondence/send')
}, {
  path: '/correspondence/send-history',
  name: 'correspondence-send-history',
  meta: _objectSpread(_objectSpread({
    title: '函证-已归档函证',
    isCpscAdmin: true
  }, meta), {}, {
    permission: ['发函操作员', '回函操作员', '函证中心管理员'],
    base: true
  }),
  props: true,
  component: _import('correspondence/send/history.vue')
}, {
  path: '/correspondence/batch',
  name: 'correspondence-batch',
  meta: _objectSpread(_objectSpread({
    title: '函证-统一发函',
    isCpscAdmin: true
  }, meta), {}, {
    permission: ['发函操作员', '函证中心管理员'],
    base: true
  }),
  component: _import('correspondence/batch')
}, {
  path: '/correspondence/reject',
  name: 'correspondence-reject',
  meta: _objectSpread(_objectSpread({
    title: '函证-统一已回置已发',
    isCpscAdmin: true
  }, meta), {}, {
    permission: ['回函操作员', '函证中心管理员'],
    base: true
  }),
  component: _import('correspondence/reject')
}, {
  path: '/correspondence/task',
  name: 'correspondence-task',
  meta: _objectSpread(_objectSpread({
    title: '函证-作业管控'
  }, meta), {}, {
    permission: ['合伙人', '经理', '现场负责人', '独立质控合伙人', '独立质控人', '查询人', '维护人', '函证中心管理员'],
    base: true
  }),
  component: _import('correspondence/task')
}, {
  path: '/correspondence/task/create/:id?',
  name: 'correspondence-task-create',
  props: true,
  meta: _objectSpread(_objectSpread({
    title: '函证-作业管控详情'
  }, meta), {}, {
    permission: ['合伙人', '经理', '现场负责人', '独立质控合伙人', '独立质控人', '查询人', '维护人', '函证中心管理员'],
    base: true
  }),
  component: _import('correspondence/task/components/create')
}, {
  path: '/correspondence/task/detail/:id',
  name: 'correspondence-task-details',
  props: true,
  meta: _objectSpread(_objectSpread({
    title: '函证-作业明细'
  }, meta), {}, {
    permission: ['合伙人', '经理', '现场负责人', '独立质控合伙人', '独立质控人', '查询人', '维护人', '函证中心管理员'],
    base: true
  }),
  component: _import('correspondence/task/components/details')
}, {
  path: '/correspondence/task/form/:id/:uid?',
  name: 'correspondence-task-form',
  props: true,
  meta: _objectSpread(_objectSpread({
    title: '函证详情'
  }, meta), {}, {
    permission: roles,
    base: true
  }),
  component: _import('correspondence/task/components/form')
}, {
  path: '/correspondence/task/history-form/:id/:uid?',
  name: 'correspondence-task-history-form',
  props: true,
  meta: _objectSpread(_objectSpread({
    title: '已归档函证详情'
  }, meta), {}, {
    permission: roles,
    base: true
  }),
  component: _import('correspondence/task/components/history-form')
}, {
  path: '/correspondence/task/preview',
  name: 'correspondence-task-preview',
  props: true,
  meta: _objectSpread(_objectSpread({
    title: '函证-函证预览'
  }, meta), {}, {
    permission: roles,
    base: true
  }),
  component: _import('template/template/view-template')
},
// {
//   path: '/statistics/correspondence',
//   name: 'statistics-correspondence',
//   meta: {
//     title: '统计-函证统计',
//     ...meta,
//     permission: 'isGroup'
//   },
//   component: _import('statistics/correspondence')
// },
// {
//   path: '/statistics/cost',
//   name: 'statistics-cost',
//   meta: {
//     title: '统计-费用统计',
//     ...meta,
//     permission: 'isGroup'
//   },
//   component: _import('statistics/cost')
// },
// {
//   path: '/statistics/workload',
//   name: 'statistics-workload',
//   meta: {
//     title: '统计-工作量统计',
//     ...meta,
//     permission: 'isGroup'
//   },
//   component: _import('statistics/workload')
// },
{
  path: '/template',
  name: 'template-page',
  meta: _objectSpread(_objectSpread({
    title: '模板-模板管控'
  }, meta), {}, {
    permission: ['admin', '函证中心管理员', '查询人', '维护人']
  }),
  component: _import('template/template')
}, {
  path: '/template/detail/:id?',
  name: 'template-detail',
  props: true,
  meta: _objectSpread(_objectSpread({
    title: '模板-模板详情'
  }, meta), {}, {
    permission: ['admin', '函证中心管理员']
  }),
  component: _import('template/template/components/template.vue')
}, {
  path: '/setting/business',
  name: 'setting-business',
  meta: _objectSpread(_objectSpread({
    title: '配置-作业类型管理'
  }, meta), {}, {
    permission: ['admin']
  }),
  component: _import('setting/business')
}, {
  path: '/setting/correspondence',
  name: 'setting-correspondence',
  meta: _objectSpread(_objectSpread({
    title: '配置-函证中心设置'
  }, meta), {}, {
    permission: ['admin']
  }),
  component: _import('setting/correspondence')
}, {
  path: '/setting/modular',
  name: 'setting-modular',
  meta: _objectSpread(_objectSpread({
    title: '配置-模块配置管理'
  }, meta), {}, {
    permission: ['admin']
  }),
  component: _import('setting/modular')
}, {
  path: '/setting/organization',
  name: 'setting-organization',
  meta: _objectSpread(_objectSpread({
    title: '配置-组织架构管理'
  }, meta), {}, {
    permission: ['admin']
  }),
  component: _import('setting/organization')
}, {
  path: '/setting/risk',
  name: 'setting-risk',
  meta: _objectSpread(_objectSpread({
    title: '配置-函证风险检查参数'
  }, meta), {}, {
    permission: ['admin']
  }),
  component: _import('setting/risk')
}, {
  path: '/setting/task',
  name: 'setting-task',
  meta: _objectSpread(_objectSpread({
    title: '配置-作业配置管理'
  }, meta), {}, {
    permission: ['admin']
  }),
  component: _import('setting/task')
}, {
  path: '/setting/template',
  name: 'setting-template',
  meta: _objectSpread(_objectSpread({
    title: '配置-函证模板管理'
  }, meta), {}, {
    permission: ['admin']
  }),
  component: _import('setting/template')
}, {
  path: '/setting/tenant',
  name: 'setting-tenant',
  meta: _objectSpread(_objectSpread({
    title: '配置-租户管理'
  }, meta), {}, {
    permission: ['admin']
  }),
  component: _import('setting/tenant')
}, {
  path: '/setting/third-party',
  name: 'setting-third-party',
  meta: _objectSpread(_objectSpread({
    title: '配置-智能第三方配置'
  }, meta), {}, {
    permission: ['admin']
  }),
  component: _import('setting/third-party')
}, {
  path: '/setting/user',
  name: 'setting-user',
  meta: _objectSpread(_objectSpread({
    title: '配置-用户表管理'
  }, meta), {}, {
    permission: ['admin']
  }),
  component: _import('setting/user')
}, {
  path: '/setting/dictionary',
  name: 'setting-dictionary',
  meta: _objectSpread(_objectSpread({
    title: '配置-数据字典'
  }, meta), {}, {
    permission: ['admin']
  }),
  component: _import('setting/dictionary')
}];
var frameIn = [{
  path: '/',
  redirect: {
    name: ''
  },
  component: layoutHeaderAside,
  children: [
  // ..._asyncRoutes,
  // 系统 前端日志
  // {
  //   path: 'log',
  //   name: 'log',
  //   meta: {
  //     title: '前端日志',
  //     auth: true
  //   },
  //   component: _import('system/log')
  // },
  // 刷新页面 必须保留
  {
    path: 'refresh',
    name: 'refresh',
    hidden: true,
    component: _import('system/function/refresh')
  },
  // 页面重定向 必须保留
  {
    path: 'redirect/:route*',
    name: 'redirect',
    hidden: true,
    component: _import('system/function/redirect')
  }]
}];

/**
 * 在主框架之外显示
 */
var frameOut = [
// 登录
{
  path: '/login',
  name: 'login',
  component: _import('system/login')
}, {
  path: '/print-queue',
  name: 'print-queue',
  component: _import('correspondence/components/print-correspondence')
}];

/**
 * 错误页面
 */
var errorPage = [{
  path: '*',
  name: '404',
  component: _import('system/error/404')
}];

// 导出需要显示菜单的
export var frameInRoutes = frameIn;
// 导出基础路由
export var frameOutRoutes = [].concat(frameOut, errorPage);
export var asyncRoutes = _asyncRoutes;
// 重新组织后导出
export default [].concat(frameIn, frameOut, errorPage);